declare var $: any;

import { Spinner } from "../modules/spinner";
import { Utils } from "../modules/utils";
import { HelpBoxComponent } from "../components/helpBoxComponent";

export class Autosave {
    // every input inside the element with this class will trigger the
    // autosave. It must not be a child of the element with resultsContainerClass,
    // or the event bindings will be lost on the first autosave
    static containerPageClass = ".js-autosave-page";

    // the form with this class will be the one submitted by autosave
    static formClass = ".js-autosave-form";

    // the contents of the element with this class will be replaced by the response
    // form the server on autosave.
    // 
    // An event called "reloaded" will be triggered on
    // this element every time the view has been autosaved (after save)
    static resultsContainerClass = ".js-autosave-replace";

    static savingNotificationClass = ".js-saving-notification";

    private static currentInputIndex = -1;
    private static currentInputSelectionStart = -1;

    static init() {
        $(Autosave.containerPageClass).on("keyup", "input[type=text]:not(.js-autosave-off)", Autosave.handleTextInputKeyPress);
        $(Autosave.containerPageClass).on("change", "input[type=radio]:not(.js-autosave-off)", Autosave.setPendingSave);
        $(Autosave.containerPageClass).on("change", "input[type=checkbox]:not(.js-autosave-off)", Autosave.setPendingSave);
        $(Autosave.containerPageClass).on("updated", "input.integer-input-value:not(.js-autosave-off)", Autosave.setPendingSave);

        $(Autosave.containerPageClass).on("click", ".forward-button", Utils.abortDebounce);
        $(Autosave.containerPageClass).on("click", ".back-button", Utils.abortDebounce);
    }

    private static handleTextInputKeyPress(e: KeyboardEvent) {
        // the enter key should not trigger autosave
        if (e.keyCode === 13 || e.which === 13) return;
        Autosave.setPendingSave();
    }

    static setPendingSave() {
        const instantSaveAttribute = $(this).data("instant-save");
        const isImmediateSave = instantSaveAttribute && instantSaveAttribute.toString().toLowerCase() === "true";

        Utils.debounce(Autosave.save, isImmediateSave ? 0 : 5000, isImmediateSave);
    }

    static triggerInstantSave(nextIndex: number) {
        if (nextIndex && $.isNumeric(nextIndex)) Autosave.currentInputIndex = nextIndex;
        Utils.abortDebounce();
        Utils.debounce(Autosave.save, 0, true);
    }

    static save() {
        const $form = $(Autosave.formClass);
        const $button = $(".forward-button");

        const url = $form.attr("action");
        const type = $form.attr("method");
        const formData = $form.serialize();

        Spinner.spin($button);
        $(Autosave.savingNotificationClass).show();

        $.ajax({
            type: type,
            url: url,
            data: formData
        }).done((responseData: any) => {
            if (Autosave.currentInputIndex < 0) {
                Autosave.currentInputIndex = Autosave.getIndexOfFocusedTextInput();
                Autosave.currentInputSelectionStart = Autosave.getSelectionStartOfFocusedTextInput();
            }
            $(Autosave.resultsContainerClass).html(responseData);
            $(Autosave.resultsContainerClass).trigger("reloadedBeforeFocus");
            Autosave.setFocusToCurrentInput();
            $(Autosave.resultsContainerClass).trigger("reloaded");
        }).always(() => {
            Spinner.stop($button);
            $(Autosave.savingNotificationClass).hide();
            HelpBoxComponent.init();
        });
    }

    private static setFocusToCurrentInput() {
        Autosave.setFocusToInput(Autosave.currentInputIndex, Autosave.currentInputSelectionStart);
        Autosave.currentInputIndex = -1;
    }

    private static setFocusToInput(index: number, selectionStart: number) {
        const $inputs = Autosave.getAllInputs();

        if (index < 0 || index >= $inputs.length) return;
        const $input = $inputs.get(index);
        $input.focus();
        $input.selectionStart = selectionStart;
    }

    static getAllInputs() {
        return $(".text-box-container input[type=text]");
    }

    private static getIndexOfFocusedTextInput() {
        const $inputs = Autosave.getAllInputs();
        return $inputs.index(Autosave.getFocusedTextInput());
    }

    private static getSelectionStartOfFocusedTextInput() {
        const $input = Autosave.getFocusedTextInput();
        if ($input.length <= 0) return -1;
        return $input[0].selectionStart;
    }

    private static getFocusedTextInput() {
        return $(".text-box-container input[type=text]:focus");
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/modules/autosave.ts